import { useContext, useEffect, useState } from "react";
import { WarningAlert } from "../../alerts/WarningAlert";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import Box from "@mui/material/Box";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  DELETE_CURSO,
  GET_ALL_COURSES,
  GET_CURSOS_IN_PLANINGS,
} from "../../Querys/querys";
import { useMutation, useQuery } from "@apollo/client";
import CheckPermission from "../../helpers/Administradores/Permissions";
import FormacionDesarolloContext from "../../context/FormacionDesarollo/FormacionDesarrolloContext";
import { updateModalCourses } from "../../context/FormacionDesarollo/FormacionDesarrolloActions";
import { SuccessfulAlert } from "../../alerts/successAlerts";
import { ErrorAlert } from "../../alerts/errorAlert";
import { useHistory } from "react-router-dom";

export const MenuCourse = (props: any) => {
  const { state, dispatch } = useContext(FormacionDesarolloContext);

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [disable, setDisable] = useState(false);
  const history = useHistory();
  const {
    data: getConteoCursos,
    startPolling,
    stopPolling,
  } = useQuery(GET_CURSOS_IN_PLANINGS, {
    variables: {
      id: parseInt(props.id),
    },
  });
  const conteo = getConteoCursos?.GET_CURSOS_IN_PLANINGS[0].conteo;
  const status = getConteoCursos?.GET_CURSOS_IN_PLANINGS[0].status;
  const open = Boolean(anchorEl);
  const openMenu = (e: any): void => {
    setAnchorEl(e.currentTarget);
  };
  const [deleteCurso] = useMutation(DELETE_CURSO, {
    refetchQueries: [{ query: GET_ALL_COURSES }],
  });

  useEffect(() => {
    startPolling(5000);
    return () => {
      stopPolling();
    };
  }, [status, startPolling, stopPolling]);

  useEffect(() => {
    if (
      getConteoCursos &&
      getConteoCursos?.GET_CURSOS_IN_PLANINGS &&
      conteo > 0
    ) {
      setDisable(true);
    }
  }, [disable, conteo]);

  useEffect(() => {
    if (
      getConteoCursos &&
      getConteoCursos?.GET_CURSOS_IN_PLANINGS &&
      status === "Activo"
    ) {
      setDisable(true);
    } else if (status === "Inactivo") {
      setDisable(false);
    }
  }, [disable, status]);

  const verCurso = (id: string, verModal: boolean) => {
    setAnchorEl(null);
    console.log(id, verModal);
    // updateCalendarsModal(id, updateModal, dispatch)
  };

  const updateModal = (id: string, createModalCourse: boolean) => {
    setAnchorEl(null);
    updateModalCourses(id, true, dispatch);
    //   updateBenefitsModal(id, updateModal, dispatch)
  };

  const deleteModal = async (id: any, active: any) => {
    setAnchorEl(null);
    let response = await WarningAlert({
      text: "¿Deseas eliminar el curso?",
      showDenyButton: true,
    });
    if (response.isConfirmed) {
      try {
        await deleteCurso({
          variables: {
            id: parseInt(id),
          },
        });
        SuccessfulAlert({ text: "El curso ha sido eliminado correctamente" });
      } catch (error) {
        console.error(error);
        ErrorAlert({ text: "Hubo un error al eliminar el curso" });
      }
    }
  };

  const menuDelete = () => {
    return (
      <MenuItem
        onClick={() => deleteModal(props.id, props.active)}
        disabled={disable}
      >
        <div className="contenedorTextoMenuCourse">
          <span className="textoMenuEliminarCourse">Eliminar</span>
        </div>
        <div className="imgDeleteCourse">
          <img
            className="iconoMenuEliminarCourse"
            src="/assets/svg/icono-eliminar.svg"
            alt="Eliminar"
          />
        </div>
      </MenuItem>
    );
  };
  return (
    <>
      <Box mr={2} className="menuListNewCourse">
        <IconButton onClick={openMenu} className="menuListOptionNewCourse">
          <MoreVertIcon className="moreOptionNewCourse" />
        </IconButton>
      </Box>
      <Menu
        className="MoreVerIcon"
        anchorEl={anchorEl}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setAnchorEl(null)}
      >
        {CheckPermission("FormacionDesarrollo.Cursos.Ver") && (
          <MenuItem
            onClick={() => {
              history.push(`/capacitaciones/${props.id}`);
            }}
          >
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Información</span>
            </div>
            <div>
              <VisibilityIcon className="iconoMenuViewCourse" />
            </div>
          </MenuItem>
        )}
        {CheckPermission("FormacionDesarrollo.Cursos.Editar") && (
          <MenuItem
            onClick={() => updateModal(props.id, true)}
            //disabled={props.isEditable ? false : true}
          >
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Editar</span>
            </div>
            <div className="imgEditaCourse">
              <img
                className="iconoMenuCourse"
                src="/assets/svg/icono-editar.svg"
                alt="Editar"
              />
            </div>
          </MenuItem>
        )}
        {CheckPermission("FormacionDesarrollo.Cursos.Eliminar") && menuDelete()}
      </Menu>
    </>
  );
};
